import {Component, Input, ViewChild} from '@angular/core';
import {DxContextMenuComponent, DxTreeListComponent} from "devextreme-angular";
import {LoginService} from "../../../../../Services/login.service";
import {CatalogService} from "../../../../../Services/CatalogManagement/catalog.service";
import {TreeItem as TreeElement} from "../../../../../Model/Dto/TreeItem";
import {ImportContainer} from "../../../../../Model/dataProcess/importContainer";
import {Category} from "../../../../../Model/Catalog/Category";
import {CategoryMappingService} from "../../../../../Services/DataProcess/categoryMapping.service";
import {CategoryMapping} from '../../../../../Model/dataProcess/categoryMapping';
import {ClickEvent} from "devextreme/ui/button";
import {GoldenRecordService} from "../../../../../Services/goldenRecord.service";
import {CategoryService} from "../../../../../Services/CatalogManagement/category.service";
import {AddItem} from "../../../../../Model/Dto/AddItem";

export type MappingState = 'mapped' | 'unmapped';
export type CategorySelectItem = Category & { groupPath: string };


@Component({
  selector: 'np-category-mapping-tab',
  templateUrl: './np-category-mapping-tab.component.html',
  styleUrl: './np-category-mapping-tab.component.css',
  standalone: false
})
export class NpCategoryMappingTabComponent {
  @ViewChild('treeList', { static: false })
  treeList?: DxTreeListComponent;

  @ViewChild('rowMenu', { static: false })
  rowMenu?: DxContextMenuComponent;

  @Input() container: ImportContainer | null = null;

  rows: any;

  goldenRecordCatalogCategories: Record<string, Category> = {};
  goldenRecordCatalogCategoryItems: CategorySelectItem[] = [];

  goldenRecordCatalogId: string = "";

  rowMenuItems = [
    { id: 'before', text: 'Kategorie hinzufügen' },
  ];
  menuVisible = false;
  menuTarget: HTMLElement | null = null;

  menuPosition: any = {
    my: { x: 'right', y: 'top' },
    at: { x: 'right', y: 'bottom' },
    of: null
  };

  menuRow?: any = null;
  public childs: TreeElement[];
  private categoryMapping: { [importId: string]: CategoryMapping } = {};
  public autoMappingMode: boolean = false;
  addCategoryVisible: boolean = false;
  newCategoryName: string = "";

  constructor(
    public loginService: LoginService,
    public catalogService: CatalogService,
    public categoryMappingService: CategoryMappingService,
    public goldenRecordService: GoldenRecordService,
    public categoryService: CategoryService
  ) {
    this.addCategory = this.addCategory.bind(this);
    this.hideAddCategory = this.hideAddCategory.bind(this);
  }

  async ngOnInit(): Promise<void> {

    this.catalogService.selectedCatalogId = this.container.activeCatalogId;
    let goldenRecord = await this.goldenRecordService.getGoldenRecord(this.loginService.currentCustomer.id);
    this.goldenRecordCatalogId = goldenRecord.catalogId;
    this.goldenRecordCatalogCategories = await this.catalogService.getAllCategoriesLeafs(this.goldenRecordCatalogId, this.loginService.currentCustomer.id);

    this.goldenRecordCatalogCategoryItems = Object.entries(this.goldenRecordCatalogCategories)
      .map(([groupPath, cat]) => ({ ...cat, groupPath }));

    const existingMappings =
      await this.categoryMappingService.getAllCategoryMappingsByCatalogId(this.container.activeCatalogId, this.loginService.currentCustomer.id);

    for (const m of existingMappings) {
      this.categoryMapping[m.importCategoryId] = m;
    }

    let that = this;
    this.rows = {
      load: async (loadOptions) => {
        let parentId = '0';
        if (loadOptions.parentIds && loadOptions.parentIds.length) {
          parentId = loadOptions.parentIds[0];
        }

        const childs = await this.catalogService.getChilds(
          this.catalogService.selectedCatalogId,
          parentId,
          this.loginService.currentUser.customerId,
          loadOptions.filter,
          this.catalogService.selectedStates,
          this.loginService.productSearchOptions,
          this.catalogService.selectedStatesMode
        );

        const filtered = childs.filter(x => x.type === 'cat' || x.type === 'grp');

        let result = filtered.map(item => {
          const mapping = this.categoryMapping[item.id];

          const hasChilds =
            (item.categoryCount === 0 && (item.productCount ?? 0) > 0)
              ? false
              : (item.hasChilds ?? true);

          return {
            ...item,
            hasChilds,
            goldenRecordCategoryId: mapping?.goldenRecordCategoryId ?? null,
            state: mapping ? 'mapped' : 'unmapped',
          };
        });

        return result;
      }
    };
  }

  async onMappingChanged(cell: any, e: any) {
    const row = cell.data;
    const newValue = e.value;

    row.goldenRecordCategoryId = e.value;

    await this.upsertCategoryMappingForRow(row, newValue);

    row.state = newValue ? 'mapped' : 'unmapped';
  }

  openRowMenu(e: any, cell: any): void {
    this.menuRow = cell.data;

    const targetElement = e.element as HTMLElement;
    this.rowMenu?.instance.option('target', targetElement);

    this.rowMenu?.instance.show();
  }

  onMenuItemClick(e: any): void {
    this.addCategoryVisible = true;
    this.menuVisible = false;
  }

  hideAddCategory(): void {
    this.addCategoryVisible = false;
  }

  async addCategory() {
    let addItem = new AddItem(
      this.menuRow.goldenRecordCategoryId,
      this.loginService.currentCustomer.id,
      "",
      this.newCategoryName
    );

    await this.categoryService.addCategory(addItem);
    this.goldenRecordCatalogCategories = await this.catalogService.getAllCategoriesLeafs(this.goldenRecordCatalogId, this.loginService.currentCustomer.id);

    this.goldenRecordCatalogCategoryItems = Object.entries(this.goldenRecordCatalogCategories)
      .map(([groupPath, cat]) => ({ ...cat, groupPath }));
    this.addCategoryVisible = false;
  }

  runAutoMapping(): void {
    this.autoMappingMode = true;
    if (!this.treeList) {
      return;
    }
    const tree = this.treeList.instance;

    tree.forEachNode(node => {
      const row: any = node.data;
      if (!row) {
        return;
      }

      if (row.state != "mapped") {
        const match = this.goldenRecordCatalogCategoryItems
          .find(x => x.groupName === row.text);

        if (match) {
          row.goldenRecordCategoryId = match.id;
          tree.cellValue(node.key, 'goldenRecordCategoryId', match.id);
        }
      }
    });
  }

  protected async saveCategoryMapping(cell: any, e: ClickEvent) {
    const row = cell.data;

    if (!row.goldenRecordCategoryId) {
      return;
    }

    await this.upsertCategoryMappingForRow(row, row.goldenRecordCategoryId);

    row.state = 'mapped';

    if (!this.treeList) return;
    const tree = this.treeList.instance;

    let allMapped = true;
    tree.forEachNode(node => {
      const r: any = node.data;
      if (!r) return;
      if (r.state !== 'mapped') {
        allMapped = false;
      }
    });

    this.autoMappingMode = !allMapped;
  }

  private async upsertCategoryMappingForRow(row: any, goldenId: string) {
    let mapping = this.categoryMapping[row.id] as CategoryMapping | undefined;

    if (!mapping) {
      mapping = {
        containerId: this.container.id,
        catalogId: this.container.activeCatalogId,
        importCategoryId: row.id,
        goldenRecordCategoryId: goldenId
      } as CategoryMapping;
    } else {
      mapping.goldenRecordCategoryId = goldenId;
    }

    this.categoryMapping[row.id] = mapping;

    const saved = await this.categoryMappingService.update(
      mapping,
      this.loginService.currentCustomer.id
    );

    this.categoryMapping[row.id] = saved;
  }
}
